import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import LayoutSelectorIcon from "../../../../../components/SVGComponents/LayoutSelectorIcon";
import LayoutSelector from "./LayoutSelector";
import { useTranslation } from "react-i18next";
import themeContext from "../../../../../context/theme/ThemeContext";
import { toolTipStyles } from "../../../styles/styles";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";

const LayoutSelect = () => {
  const dropDownRef = useRef(null);
  const { theme } = useContext(themeContext);
  const [isActive, setIsActive] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [hovered, setHovered] = useState(false);
  const { t } = useTranslation();
  const handleMouseClick = () => {
    setIsActive(!isActive);
    setHovered(false);
    setClicked(!clicked);
    // document.getElementsByClassName(
    //   "layout-selector-tooltip"
    // )[0].style.display = "none";
  };

  const handleLayoutClick = () => {
    setIsActive(!isActive);
    setHovered(false);
    setClicked(false);
  };

  const handleMouseOver = () => {
    // console.log(clicked);
    if (!clicked) {
      setIsActive(true);
      setHovered(true);
    }
  };

  const handleMouseDown = () => {
    // if (!clicked) {
    setIsActive(false);
    setHovered(false);
    // }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        console.log("Condition matched");
        setClicked(false);
        setIsActive(false);
        setHovered(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return (
    <>
      <CustomToolTipHost
        delay={TooltipDelay.zero}
        id="layout-selector"
        directionalHint={DirectionalHint.rightCenter}
        content={t("viewer.tools.grid-layout")}
        styles={toolTipStyles}
        className="layout-selector-tooltip"
      >
        <div className="highlight-tool" aria-describedby="layout-selector">
          <div
            // className="h100 w100"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onMouseOver={handleMouseOver}
            onMouseLeave={handleMouseDown}
            onClick={handleMouseClick}
          >
            <LayoutSelectorIcon
              color={
                hovered ? theme.palette.activeTool : theme.palette.inactiveTool
              }
            />
          </div>

          {/* <div
          style={{
            position: "relative",
            display: "flex",
            alignItems: "center",
          }}
          onClick={handleMouseClick}
          onMouseOver={handleMouseOver}
          onMouseLeave={handleMouseDown}
          className="cursor-pointer"
          >
          {isActive ? <ActiveLayoutSelectorIcon /> : <LayoutSelectorIcon />}
        </div> */}

          {/* {hovered && !clicked && (
          <div
        style={{
          height: "55px",
          width: "110px",
          position: "absolute",
          left: "60px",
          fontSize: "12px",
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
          zIndex: "999",
        }}
        >
        <div
        style={{
          height: "25px",
          backgroundColor: "#3A3A39",
          padding: "0 20px",
        }}
        >
        Grid Layout
        </div>
        </div>
      )} */}
        </div>
      </CustomToolTipHost>
      {clicked && (
        <div
          ref={dropDownRef}
          style={{
            height: "fit-content",
            width: "fit-content",
            position: "absolute",
            top: window.innerHeight * 0.075,
            backgroundColor: "#3A3A39",
            zIndex: "999",
            padding: "0px 10px 10px 10px",
          }}
        >
          <LayoutSelector handleMouseClick={handleLayoutClick} />
        </div>
      )}
    </>
  );
};

export default LayoutSelect;
